import { render, staticRenderFns } from "./index3.5.vue?vue&type=template&id=ec33a50c&scoped=true"
import script from "./index3.5.vue?vue&type=script&lang=js"
export * from "./index3.5.vue?vue&type=script&lang=js"
import style0 from "./index3.5.vue?vue&type=style&index=0&id=ec33a50c&prod&lang=css"
import style1 from "./index3.5.vue?vue&type=style&index=1&id=ec33a50c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec33a50c",
  null
  
)

export default component.exports